function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  id: "\\uD569\\uCE58\\uAE30_27",
  "data-name": "\\uD569\\uCE58\\uAE30 27",
  d: "M-1982.392,16.358V9.891h-6.467A1.141,1.141,0,0,1-1990,8.75a1.141,1.141,0,0,1,1.141-1.141h6.467V1.141A1.142,1.142,0,0,1-1981.25,0a1.141,1.141,0,0,1,1.141,1.141V7.609h6.467A1.141,1.141,0,0,1-1972.5,8.75a1.141,1.141,0,0,1-1.142,1.141h-6.467v6.467a1.141,1.141,0,0,1-1.141,1.142A1.142,1.142,0,0,1-1982.392,16.358Z",
  transform: "translate(1990.5 0.5)",
  fill: "#e6e6e6",
  stroke: "rgba(0,0,0,0)",
  strokeMiterlimit: 10,
  strokeWidth: 1
});

var SvgPlus = function SvgPlus(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18.5,
    height: 18.5,
    viewBox: "0 0 18.5 18.5",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgPlus, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/plus.3b328f00.svg";
export { ForwardRef as ReactComponent };